export default __webpack_public_path__ + "static/media/LidarDark.63c6eb52.svg";